import { CommonSelectInput } from 'components/common/form/select';
import { PLAYER_LEVELS, PlayerLevel } from 'lib_ts/enums/pitches.enums';
import { clone } from 'lodash';
import useHittersStore from 'stores/use-hitters-store';

export const SelectHitterLevel = () => {
  const loading = useHittersStore((s) => s.loading);
  const filters = useHittersStore((s) => s.filters);

  return (
    <CommonSelectInput
      id="hitters-level"
      name="level"
      placeholder="common.level"
      options={PLAYER_LEVELS}
      value={filters.level}
      onChange={(v) =>
        useHittersStore.setState((prev) => {
          const nextFilters = clone(prev.filters);

          if (!v) {
            delete nextFilters.level;
          } else {
            nextFilters.level = v as PlayerLevel;
          }

          return {
            filters: nextFilters,
          };
        })
      }
      disabled={loading}
      optional
      skipSort
    />
  );
};
